function NumberArrayConverter(val) {
    if (typeof val === "string") {
        return new Float32Array(val.split(",").map(f => parseFloat(f)));
    }
    else if (Array.isArray(val)) {
        return new Float32Array(val);
    }
    else if (val instanceof Float32Array) {
        return val;
    }
}
export default NumberArrayConverter;



// WEBPACK FOOTER //
// ./src/Converters/NumberArrayConverter.ts